import { useForm } from '@tanstack/react-form';
import { useCreateSaleMutation } from './mutations/use-create-sale.mutation';
import { CreateSaleResponse } from '@/types/api/sale';

export function useCreateSaleForm(initialRoundId: string | undefined, onSuccess?: (data: CreateSaleResponse) => void) {
  const mutation = useCreateSaleMutation();

  return useForm({
    defaultValues: {
      participationCount: 30,
      participationUnitCountTarget: 10,
      cutoffId: initialRoundId || '',
    },
    validators: {},
    onSubmit: async ({ value }) => {
      await mutation.mutateAsync(
        {
          participationUnitCountTarget: value.participationUnitCountTarget,
          unitCountTarget: value.participationCount * value.participationUnitCountTarget,
          startImmediately: true,
          cutoffId: value.cutoffId,
        },
        { onSuccess },
      );
    },
  });
}
